// src/components/CustomFooter.js

import React from "react";
import PropTypes from "prop-types";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import MuiTablePagination from "@material-ui/core/TablePagination";
import { withStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { updateFilterField, updateData } from "../redux/actions";

const defaultFooterStyles = {};
const CustomFooter = ({ textLabels, count, page, onPageChange, pageMarker }) => {
  const dispatch = useDispatch();

  // Use Redux page state (MUI is zero-indexed; Redux is 1-indexed)
  const currentPage = useSelector((state) => state.filters.page - 1);
  const currentMarker = useSelector((state) => state.filters.pageMarker);
  const totalDocCount = useSelector((state) => state.totalDocCount || 0);

  const handlePageChange = (_, newPage) => {
    // Update Redux store
    dispatch(updateData([["loading...", "loading...", "loading...", "loading..."]]));
    dispatch(updateFilterField("page", newPage + 1));
    dispatch(updateFilterField(pageMarker));
    // Let MUI know to update its internal state
    if (onPageChange) {
      onPageChange(newPage);
    }
  };

  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={1000} style={{ display: "flex", justifyContent: "flex-end" }}>
          <MuiTablePagination
            component="div"
            count={totalDocCount}
            rowsPerPage={50}
            page={page}
            labelRowsPerPage={textLabels.rowsPerPage}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} ${textLabels.displayRows} ${count}`
            }
            backIconButtonProps={{ "aria-label": textLabels.previous }}
            nextIconButtonProps={{ "aria-label": textLabels.next }}
            rowsPerPageOptions={[]} // disable rows-per-page change
            onPageChange={handlePageChange}
            onRowsPerPageChange={() => {}} // no-op since rowsPerPage is fixed
          />
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

CustomFooter.propTypes = {
  textLabels: PropTypes.object,
};

export default withStyles(defaultFooterStyles, { name: "CustomFooter" })(CustomFooter);
